import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';
import DuplicateViewTable from '../tables/DuplicateViewTable';

/**
 * 重複確認モーダル
 */
const DuplicateModal = ({ dataTable, isFreshness, isContinuation, onOk, onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal
            size="xl"
            isShow={true}
            onClose={onClose}
            isShowIconClose="true"
            title={t('modal.common_modal.title')}
            btnList={[
                {
                    name: t('button.OK'),
                    className: 'btn--primary',
                    onClick: onOk,
                    disabled: false,
                },
                {
                    name: t('button.cancel'),
                    className: 'btn--secondary',
                    onClick: onClose,
                    disabled: false,
                },
            ]}
        >
            <p className="text-center">すでに同じ内容が登録されています。</p>
            <p className="text-center">商品の登録をスキップします。</p>
            <DuplicateViewTable dataTable={dataTable} isFreshness={isFreshness} isContinuation={isContinuation} />
        </Modal>
    );
};

export default DuplicateModal;
